// Module
var code = "<svg width=\"18\" height=\"6\" viewBox=\"0 0 18 6\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <rect y=\"0.286133\" width=\"18\" height=\"5\" rx=\"2\" fill=\"#D9D9D9\"/> </svg> ";
// Exports
module.exports = code;